// angular
import { AfterViewInit, Component, HostListener, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CoreService } from '../../../core/core.service';
import { AppService } from '../../../app.service';
import { KlenicoMeService } from '../../me.service';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
    selector: 'me-quick-test-result',
    templateUrl: './quick-test-result.component.html',
    styleUrls: ['./quick-test-result.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class MeQuickTestResultComponent implements OnInit, AfterViewInit {
    data: any;
    imageBlock: any;
    helpBlock: any;
    url = 'lp/quick-test/result/';
    slug = '';
    replaceText;
    isHarm;
    showHelpCard = false;
    numberOfSigns = 0;
    totalSigns = 9;

    @ViewChild('modal',  {static: false}) modal: ModalDirective;

    constructor(
        public appService: AppService,
        public meService: KlenicoMeService,
        public translate: TranslateService,
        public route: ActivatedRoute,
        public coreService: CoreService,
        public router: Router
    ) {
       
    }

    ngAfterViewInit() {
        this.coreService.className = 'me-landing-page';
        this.meService.isLandingPage = true;
    }

    ngOnInit() {

        this.translate.onLangChange.subscribe(value => {
            this.getContent();
        });

        this.route.paramMap.subscribe((params: ParamMap) => {
            this.slug = params.get('slug');
            if (params.get('numberCategories')) {
                this.numberOfSigns = parseInt(params.get('numberCategories'));
                this.replaceText = {
                    numberOfSigns : this.numberOfSigns
                };
            }

            if (params.get('isHarm')) {
                this.isHarm = parseInt(params.get('isHarm'));
                this.showHelpCard = this.isHarm || this.numberOfSigns >= 2;

                const sliderValue = this.isHarm ? 93 : this.numberOfSigns === 0 ? 7 
                    : 55 + (93 - 55) * (this.numberOfSigns / this.totalSigns);

                this.replaceText = {
                    numberOfSigns : this.numberOfSigns,
                    value : sliderValue
                };
            }
            
            
            this.getContent();
        });
    }

    getContent() {
        this.appService.getStoryBlokDataForClinic(this.url + this.slug).subscribe(res => {
            this.data = res['story']['content'] ?? [];
            this.imageBlock = res['story']['content']['content'][0] ?? [];
            this.appService.isLoading = false;
        });
    }

    back() {
        history.back();
    }
}
